import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fundingWalletRefreshQuery, fundingWalletRefreshState } from './wallet-refresh.js';
export function useFundingWalletRefresh(input, refresh) {
  const $ = _c(11);
  let t0;
  if ($[0] !== input || $[1] !== refresh) {
    t0 = fundingWalletRefreshQuery(input, refresh);
    $[0] = input;
    $[1] = refresh;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const query = useQuery(t0);
  let t1;
  if ($[3] !== input.providerDelivered || $[4] !== query.isError || $[5] !== query.isFetching || $[6] !== query.isSuccess) {
    t1 = fundingWalletRefreshState(input.providerDelivered, query.isFetching, query.isError, query.isSuccess);
    $[3] = input.providerDelivered;
    $[4] = query.isError;
    $[5] = query.isFetching;
    $[6] = query.isSuccess;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== query || $[9] !== t1) {
    t2 = {
      state: t1,
      retry() {
        query.refetch();
      }
    };
    $[8] = query;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}